import * as React from 'react';
import { NavLinkProps } from 'react-router-dom';

import { Text12M } from '@sternum/ui';

import { LinkStyled } from './Link.styles';

export const Link: React.ForwardRefExoticComponent<NavLinkProps & React.RefAttributes<HTMLAnchorElement>> =
  React.forwardRef(function Link({ children, ...props }: NavLinkProps, ref) {
    return (
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      <LinkStyled aria-label="application header link" {...props} ref={ref}>
        {(...args) => <Text12M>{typeof children === 'function' ? children(...args) : children}</Text12M>}
      </LinkStyled>
    );
  });
